import Swiper, { Pagination, Navigation } from 'swiper';

const params = {
    parentSelector: '.product-page__reviews-list--mobile',
    containerSelector: '.js-reviews-slider .swiper-container',
    paginationSelector: '.js-reviews-slider .swiper-pagination',
};

Swiper.use([Pagination, Navigation]);

export function initReviewsSlider() {
    const container = $(params.containerSelector)[0];

    if (!container) {
        return;
    }

    const reviewsSlider = new Swiper(container, {
        loop: false,
        slidersPerView: 1,
        cssMode: true,
        pagination: {
            el: params.paginationSelector,
            clickable: true,
        },
    });

    reviewsSlider.on('slideChange', (e) => {
        // eslint-disable-next-line prefer-rest-params
        console.log(e);
    });
}
